'use strict';
import angular from 'angular';
import OrderSummaryListController from './order-summary-list.controller';
import CartService from '../../app/cart/cart.service';
import giftCardBalance from '../giftCardBalance';
import ItemWarningsService from './item-warnings.service';
import { OrderSummaryEvents } from './order-summary.events';
export default angular.module('directives.orderList', [giftCardBalance])
    .controller('OrderSummaryListController', OrderSummaryListController)
    .service('OrderSummaryEvents', OrderSummaryEvents)
    .service('CartService', CartService)
    .service('ItemWarningsService', ItemWarningsService)
    .component('orderSummaryList', {
    template: require('./order-summary-list.html'),
    bindings: {
        loadingBar: '<',
        cart: '<',
        onCartChange: '&'
    },
    controller: OrderSummaryListController
})
    .name;
//# sourceMappingURL=index.js.map